import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import Header from './components/Header'
import Footer from './components/Footer'
import ScrollToTop from './components/ScrollToTop'
import WhatsAppButton from './components/WhatsAppButton'

// Import all pages
import Home from './pages/Home'
import About from './pages/About'
import Services from './pages/Services'
import Contact from './pages/Contact'
import FAQ from './pages/FAQ'
import Careers from './pages/Careers'
import TemporaryStaffing from './pages/TemporaryStaffing'
import PermanentPlacement from './pages/PermanentPlacement'
import ExecutiveSearch from './pages/ExecutiveSearch'
import PayrollServices from './pages/PayrollServices'
import HRConsulting from './pages/HRConsulting'
import TrainingDevelopment from './pages/TrainingDevelopment'
import IndustrySolutions from './pages/IndustrySolutions'
import TechnologyStaffing from './pages/TechnologyStaffing'
import HealthcareStaffing from './pages/HealthcareStaffing'
import FinanceStaffing from './pages/FinanceStaffing'
import ManufacturingStaffing from './pages/ManufacturingStaffing'
import RetailStaffing from './pages/RetailStaffing'
import Caretakers from './pages/Caretakers'
import Telecallers from './pages/Telecallers'
import Housekeeping from './pages/Housekeeping'
import OfficeBoys from './pages/OfficeBoys'
import Watchman from './pages/Watchman'
import WardBoys from './pages/WardBoys'
import Security from './pages/Security'
import AccountingJobs from './pages/AccountingJobs'
import AnyDegreeJobs from './pages/AnyDegreeJobs'
import Drivers from './pages/Drivers'
import DeliveryBoys from './pages/DeliveryBoys'
import EventServices from './pages/EventServices'
import FinancialServices from './pages/FinancialServices'
import FinancialForm from './pages/FinancialForm'

function App() {
  return (
    <Router>
      <div className="min-h-screen flex flex-col">
        <ScrollToTop />
        <Header />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/financial-services" element={<FinancialServices />} />
            <Route path="/financial-services/apply" element={<FinancialForm />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/careers" element={<Careers />} />
            
            {/* Service-specific pages (match Services page + Home office link) */}
            <Route path="/services/housekeeping" element={<Housekeeping />} />
            <Route path="/services/office-boys" element={<OfficeBoys />} />
            <Route path="/services/watchman" element={<Watchman />} />
            <Route path="/services/ward-boys" element={<WardBoys />} />
            <Route path="/services/security" element={<Security />} />
            <Route path="/services/accounting-jobs" element={<AccountingJobs />} />
            <Route path="/services/any-degree-jobs" element={<AnyDegreeJobs />} />
            <Route path="/services/drivers" element={<Drivers />} />
            <Route path="/services/delivery-boys" element={<DeliveryBoys />} />
            <Route path="/services/event-services" element={<EventServices />} />
            <Route path="/services/temporary-staffing" element={<TemporaryStaffing />} />
            <Route path="/services/permanent-placement" element={<PermanentPlacement />} />
            <Route path="/services/executive-search" element={<ExecutiveSearch />} />
            <Route path="/services/payroll-services" element={<PayrollServices />} />
            <Route path="/services/hr-consulting" element={<HRConsulting />} />
            <Route path="/services/training-development" element={<TrainingDevelopment />} />
            <Route path="/services/caretakers" element={<Caretakers />} />
            <Route path="/services/telecallers" element={<Telecallers />} />
            <Route path="/services/car-washing" element={<Navigate to="/services/telecallers" replace />} />
            <Route path="/services/deep-cleaning" element={<Navigate to="/services/caretakers" replace />} />
            
            {/* Industry-specific pages */}
            <Route path="/solutions/industry-solutions" element={<IndustrySolutions />} />
            <Route path="/solutions/technology-staffing" element={<TechnologyStaffing />} />
            <Route path="/solutions/healthcare-staffing" element={<HealthcareStaffing />} />
            <Route path="/solutions/finance-staffing" element={<FinanceStaffing />} />
            <Route path="/solutions/manufacturing-staffing" element={<ManufacturingStaffing />} />
            <Route path="/solutions/retail-staffing" element={<RetailStaffing />} />
          </Routes>
        </main>
        <Footer />
        <WhatsAppButton />
      </div>
    </Router>
  )
}

export default App
